module.exports = __webpack_public_path__ + "img/invitations_3.7556ef19.jpg";